import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import ThirdServerAPI from '../../api/thirdServer';
import { throwErrorMessage } from '../utils/api';
import { IDBObjectStore } from 'fake-indexeddb';

const state = {
  room: {},
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isUpdating: false,
    isCheckoutInProcess: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  // 改为普通函数
  getRoomDetail($state) {
    return (roomId) => $state.records.find(record => record.id === roomId)
  }
};

export const actions = {
  getRoomDetail: async ({ commit }, data) => {
    try {
      const response = await ThirdServerAPI.getRoomDetail(data);
      if (response?.data?.code != 200) {
        useAlert(response?.data?.message);
        return
      } else {
        commit(types.default.SET_ROOM, response?.data?.data?.item);
      }
      return response?.data?.data?.item
    } catch (error) {
      throwErrorMessage(error);
    } finally {
    }
  },
  enableRoomGPT: async ({ commit }, data) => {
    try {
      const response = await ThirdServerAPI.enableRoomGPT(data);
      if (response?.data?.code != 200) {
        useAlert(response?.data?.message);
        return
      } else {
        commit(types.default.SET_ROOM, response?.data?.data?.item);
      }
      return response?.data?.data?.item
    } catch (error) {
      throwErrorMessage(error);
    } finally {
    }
  },
  disabledRoomGPT: async ({ commit }, data) => {
    try {
      const response = await ThirdServerAPI.disabledRoomGPT(data);
      if (response?.data?.code != 200) {
        useAlert(response?.data?.message);
        return
      } else {
        commit(types.default.SET_ROOM, response?.data?.data?.item);
      }
      return response?.data?.data?.item
    } catch (error) {
      throwErrorMessage(error);
    } finally {
    }
  },
}


export const mutations = {
  [types.default.SET_ROOM]: MutationHelpers.set,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
